import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { useCompanyUserStore } from "./companyUserStore";

interface CompanyStore {
    companyId: string | null;
    isCompanyLoading: boolean;
    companyError: string | null;

    fetchCompanyId: () => Promise<void>;
    setCompanyId: (companyId: string | null) => void;
    clearCompanyData: () => void;

    hasCompanyId: () => boolean;
}

export const useCompanyStore = create<CompanyStore>()(
    devtools(
        (set, get) => ({
            companyId: null,
            isCompanyLoading: false,
            companyError: null,

            fetchCompanyId: async () => {
                const companyUser = useCompanyUserStore.getState().companyUser;
                if (!companyUser) {
                    set(
                        { companyError: "No company user available" },
                        false,
                        "fetchCompanyId/noCompanyUser",
                    );
                    return;
                }

                set(
                    {
                        companyId: companyUser.company_id,
                        companyError: null,
                    },
                    false,
                    "fetchCompanyId/fromCompanyUser",
                );
            },

            setCompanyId: (companyId) => {
                set({ companyId }, false, "setCompanyId");
            },

            clearCompanyData: () =>
                set(
                    {
                        companyId: null,
                        isCompanyLoading: false,
                        companyError: null,
                    },
                    false,
                    "clearCompanyData",
                ),

            hasCompanyId: () => get().companyId !== null,
        }),
        {
            name: "company-store",
        },
    ),
);

export const useCompanyId = () => useCompanyStore((state) => state.companyId);
export const useHasCompanyId = () =>
    useCompanyStore((state) => state.hasCompanyId());
export const useCompanyLoading = () =>
    useCompanyStore((state) => state.isCompanyLoading);
export const useFetchCompanyId = () =>
    useCompanyStore((state) => state.fetchCompanyId);
export const useSetCompanyId = () =>
    useCompanyStore((state) => state.setCompanyId);
